module.exports = __webpack_public_path__ + "static/media/download.15a3a918.svg";